import React from 'react';
import { FormControlLabel, Checkbox, Typography, Box, FormControl } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircle from '@mui/icons-material/CheckCircle';

interface ProceedCheckboxProps {
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
	error?: boolean;
	isPaymentPlan?: boolean;
	paymentPlanVersion: number;
}

const getLabelText = (paymentPlanVersion: number, isPaymentPlan?: boolean) => {
	if (paymentPlanVersion === 2) {
		return isPaymentPlan ? 'I would like to set up a Split Payment Plan' : 'I would like to proceed with this payment';
	}
	return 'I would like to proceed with this payment';
};

const ProceedCheckbox: React.FC<ProceedCheckboxProps> = ({
	checked,
	onChange,
	error,
	isPaymentPlan,
	paymentPlanVersion,
}) => (
	<FormControl component='fieldset' error={error}>
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				my: 2,
				px: { lg: 3, xs: 0 },
			}}
		>
			<FormControlLabel
				control={
					<Checkbox
						id='proceed'
						name='proceed'
						checked={checked}
						onChange={onChange}
						icon={<CircleOutlinedIcon color={error ? 'error' : 'action'} />}
						checkedIcon={<CheckCircle />}
						sx={{
							color: error ? 'error.main' : 'primary.main',
							'&.Mui-checked': {
								color: error ? 'error.main' : 'primary.main',
							},
							'& .MuiSvgIcon-root': { fontSize: '3rem' },
						}}
					/>
				}
				label={
					<Typography variant='body1' sx={{ fontWeight: 'bold' }}>
						{getLabelText(paymentPlanVersion, isPaymentPlan)}
					</Typography>
				}
				sx={{
					'.MuiTypography-body1': {
						fontSize: '1rem',
						color: error ? 'error.main' : 'inherit',
					},
				}}
				labelPlacement='end'
			/>
		</Box>
	</FormControl>
);

export default ProceedCheckbox;
